const CaseType = {
  Case: 'Case',
  Complaint: 'Complaint',
  InsuranceClaim: 'InsuranceClaim',
  Repair: 'Repair',
  Sales: 'Sales',
};

export default CaseType;
